export default __webpack_public_path__ + "static/media/icon_html.712e1f27.svg";